import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { createResourceLocatorString } from '../../../../util/routes';
import { useRouteConfiguration } from '../../../../context/routeConfigurationContext';
import { CREATOR_SEARCH_ID, CREATORS_GENRES_FILTER } from '../../../../constants';
import { HorizontalItemsSlider } from '../../../../components';
import { creatorGenresSelector, fetchCreatorGenres } from '../../../CreatorLandingPage/CreatorLandingPage.duck';

const CreatorGenres = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const routeConfiguration = useRouteConfiguration();
    const genres = useSelector(creatorGenresSelector);

    useEffect(() => {
        dispatch(fetchCreatorGenres());
    }, []);

    const handleGenreClick = (genre) => {
        history.push(
            createResourceLocatorString(
                'SearchPage',
                routeConfiguration,
                { searchId: CREATOR_SEARCH_ID },
                { [CREATORS_GENRES_FILTER]: genre }
            )
        );
    };

    return (
        <HorizontalItemsSlider items={genres || []} onClick={(item) => handleGenreClick(item)} />
    );
};

export default CreatorGenres;
